import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx } from "vue"

import { LockClosedIcon, PlusCircleIcon } from "@heroicons/vue/24/outline";
import { useI18n } from "vue-i18n";
import BasicMenu from "@/components/other/BasicMenu.vue";
import { ReportPlotType } from "@/types/Report";
import { usePlotTypes } from "@/views/reports/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddReportMenu',
  props: {
    menuPosition: { default: "center" }
  },
  emits: ["createReport"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const { t } = useI18n();

const plotTypes = usePlotTypes();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BasicMenu, { position: _ctx.menuPosition }, {
    icon: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _createVNode(_unref(PlusCircleIcon), { class: "text-yellow-300 cursor-pointer hover:text-yellow-500 transition-colors w-10 h-10" })
      ])
    ]),
    content: _withCtx(({ item }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(plotTypes), (plotType) => {
        return (_openBlock(), _createBlock(_resolveDynamicComponent(item), {
          onClick: ($event: any) => (plotType.enabled && emit('createReport', plotType.type)),
          key: plotType.type
        }, {
          default: _withCtx(({ active }) => [
            _createElementVNode("span", {
              class: _normalizeClass([
            active && plotType.enabled
              ? 'bg-gray-100 text-yellow-600 cursor-pointer '
              : 'text-gray-700',
            'flex items-center px-4 py-2',
          ])
            }, [
              _createTextVNode(_toDisplayString(_unref(t)(`analytics.reports.${plotType.type}_plot`)) + " ", 1),
              (!plotType.enabled)
                ? (_openBlock(), _createBlock(_unref(LockClosedIcon), {
                    key: 0,
                    class: "h-4 w-4 ml-2"
                  }))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 2
        }, 1032, ["onClick"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["position"]))
}
}

})